import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from '../src/Componentes/UserContext';
import { useVersionCheck } from '../src/hooks/useVersionCheck';
import Home from './Componentes/Home/index';
import Menu from './Componentes/Menu/index';
import Cliente from './Componentes/Cliente/index';
import Produto from './Componentes/Produto/index';
import Venda from './Componentes/Venda/index';
import Footer from './Componentes/Footer/index';
import Relatorio from './Componentes/Relatorio/index.jsx';
import Agenda from './Componentes/Agenda/index.jsx';
import Gerencial from './Componentes/Gerencial/index.jsx';
import Televendas from './Componentes/Televendas/index.jsx';
import Assistente from './Componentes/Assistente/index.jsx';

const App = () => {
  useVersionCheck(); // verifica a cada 60s se há nova versão

  return (
    <UserProvider>
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/cliente" element={<Cliente />} />
            <Route path="/produto" element={<Produto />} />
            <Route path="/venda" element={<Venda />} />
            <Route path="/relatorio" element={<Relatorio />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/gerencial" element={<Gerencial />} />
            <Route path="/televendas" element={<Televendas />} />
            <Route path="/assistente" element={<Assistente />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </UserProvider>
  );
};

export default App;